import { Controller } from '@hotwired/stimulus'
import { i18n } from '@lingui/core'
import { t } from '@lingui/core/macro'
import { I18nProvider } from '@lingui/react'
import { Trans } from '@lingui/react/macro'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { createRoot } from 'react-dom/client'

export default class extends Controller {
  static targets = ['activeCheckbox', 'originalActive', 'configurationFieldset', 'statusBadge']
  static values = { featureName: String }

  connect() {
    this.updateConfigurationState()
  }

  submit(event) {
    const isActive = this.activeCheckboxTarget.checked
    const wasActive = this.originalActiveTarget.value === 'true'
    if (isActive !== wasActive) {
      event.preventDefault()
      this.showConfirmationModal(isActive ? 'activate' : 'deactivate')
    }
  }

  handleActiveChange() {
    this.updateConfigurationState()
  }

  updateConfigurationState() {
    const isActive = this.activeCheckboxTarget.checked

    if (this.hasConfigurationFieldsetTarget) {
      this.configurationFieldsetTarget.disabled = !isActive
    }

    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = isActive ? i18n._(t`Active`) : i18n._(t`Inactive`)
      this.statusBadgeTarget.classList.toggle('bg-success', isActive)
      this.statusBadgeTarget.classList.toggle('bg-secondary', !isActive)
      this.statusBadgeTarget.classList.toggle('bg-light', !isActive)
      this.statusBadgeTarget.classList.toggle('text-dark', !isActive)
    }
  }

  showConfirmationModal(action) {
    const actionLabel = action === 'activate' ? t`Activate` : t`Deactivate`
    const actionVerb = action === 'activate' ? t`activate` : t`deactivate`
    const modalContainer = document.createElement('div')
    modalContainer.id = 'feature-confirmation-modal-container'
    document.body.appendChild(modalContainer)

    const root = createRoot(modalContainer)

    const ConfirmationModal = () => {
      const [show, setShow] = React.useState(true)

      const handleConfirm = () => {
        setShow(false)
        const form = this.element
        if (form) {
          form.submit()
        }
        setTimeout(() => {
          document.body.removeChild(modalContainer)
        }, 100)
      }

      const handleCancel = () => {
        setShow(false)
        setTimeout(() => {
          document.body.removeChild(modalContainer)
        }, 100)
      }

      return (
        <Modal show={show} onHide={handleCancel} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Trans>Confirm Feature {actionLabel}</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Trans>
                This will {actionVerb} the <strong>{this.featureNameValue}</strong> feature.
              </Trans>
            </p>
            <p className='mb-0'>
              <Trans>Do you want to continue?</Trans>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCancel}>
              <Trans>Cancel</Trans>
            </Button>
            <Button variant='primary' onClick={handleConfirm}>
              <Trans>Confirm</Trans>
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }

    root.render(
      <I18nProvider i18n={i18n}>
        <ConfirmationModal />
      </I18nProvider>,
    )
  }
}
